// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomAppState } from "@stoneage/App/Store/Reducers";

export type Parameter = {
    filterType:
        | "OnlyShowMyProducts"
        | "PageNumber"
        | "PageSize"
        | "SortType"
        | "Application"
        | "DocumentTypes"
        | "ProductLines"
        | "OnlyShowActiveDocuments"
        | "OnlyShowDiscontinuedDocuments"
        | "Query";
    value?: string | boolean;
};

type HandlerType = Handler<Parameter, {}>;

export const RemoveApplicationsFilter: HandlerType = props => {
    if (props.parameter.filterType === "Application") {
        const applicationFilter = (props.getState() as CustomAppState).xProductInfo.filters.applications;
        const newFilteredFacets = applicationFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveDocumentTypesFilter: HandlerType = props => {
    if (props.parameter.filterType === "DocumentTypes") {
        const documentsFilter = (props.getState() as CustomAppState).xProductInfo.filters.documentTypes;
        const newFilteredFacets = documentsFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveProductLinesFilter: HandlerType = props => {
    if (props.parameter.filterType === "ProductLines") {
        const productLineFilter = (props.getState() as CustomAppState).xProductInfo.filters.productLines;
        const newFilteredFacets = productLineFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveQueryFilter: HandlerType = props => {
    if (props.parameter.filterType === "Query") {
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: "",
        } as any);
    }
};

export const RemoveOnlyShowMyProductsFilter: HandlerType = props => {
    if (props.parameter.filterType === "OnlyShowMyProducts") {
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: false,
        } as any);
    }
};

export const RemoveOnlyShowActiveDocumentsFilter: HandlerType = props => {
    if (props.parameter.filterType === "OnlyShowActiveDocuments") {
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: false,
        } as any);
    }
};

export const RemoveOnlyShowDiscontinuedDocumentsFilter: HandlerType = props => {
    if (props.parameter.filterType === "OnlyShowDiscontinuedDocuments") {
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: false,
        } as any);
    }
};

export const chain = [
    RemoveApplicationsFilter,
    RemoveDocumentTypesFilter,
    RemoveProductLinesFilter,
    RemoveQueryFilter,
    RemoveOnlyShowMyProductsFilter,
    RemoveOnlyShowActiveDocumentsFilter,
    RemoveOnlyShowDiscontinuedDocumentsFilter,
];

const removeProductInformationFilter = createHandlerChainRunner(chain, "RemoveProductInformationFilter");
export default removeProductInformationFilter;
